/*** Approval shell */

import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IBtn, IFpxShell, IShellButtonAction } from '../models/shell.model';

@Injectable({
  providedIn: 'root',
})
export class FpxApprovalShellService implements IFpxShell {

  constructor() {}

  doPreInit(): void {
    throw new Error('Method not implemented.');
  }

  formGroup!: FormGroup<any>;

  public onBtnClick = (action: any) => {
    // this[action]()
    console.log('btn action')
  };

  btnList: IBtn[] = [
    {
      label: 'Cancel',
      buttonClass: 'btn-tertiary',
      buttonType: 'button',
      buttonAction: 'onCancel',
    },
    {
      label: 'Approval',
      buttonClass: 'btn-primary',
      buttonType: 'button',
      buttonAction: 'onApprove',
    },
  ];
  _setFormGroup(form:FormGroup){
    this.formGroup = form;
    this.loadDependencies();
  }

  loadDependencies(){

  }


  onApprove = (): void => {};
  onReject = (): void => {};
  onCancel = (): void => {};
  onDelegate = (): void => {};
}
